import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { Close } from 'jbc-front/components/icons';
import styles from './NotifyJob.scss';

const NotifyCsvError = ({ errors }) => {
  const [showNotify, setShowNotify] = useState(true);
  const { t } = useTranslation();

  useEffect(
    () => {
      if (errors || errors?.length > 0) setShowNotify(true);
    },
    [errors]
  );

  const hideNotify = () => {
    setShowNotify(false);
  };

  return (
    showNotify && (
      <div className={styles.errorWrap}>
        <div onClick={hideNotify} className={styles.close} role="presentation">
          <Close size={20} />
        </div>
        <div className={styles.inner}>
          <p className={styles.title}>{t('features.Employees.components.NotifyCsvError.failed_to_export_CSV')}</p>
          <ul style={{ listStyle: 'disc' }}>
            {_.isArray(errors) && errors?.length > 0 ? errors.map((error, index) => <li key={`errors-${index + 1}`}>{error}</li>) : errors}
          </ul>
        </div>
      </div>
    )
  );
};

export default NotifyCsvError;
